

















































































import dayjs from 'dayjs'
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import { clone, equals, difference } from 'ramda'
import firebase from 'firebase'
import { db } from '../../firebase/init'
import { NewMessageType } from '../../types'
import CDatePicker from '../inputs/CDatePicker.vue'
import MainMixin from '../../mixins/MainMixin'
import FindCustomer from '../customers/FindCustomer.vue'

@Component({
  components: {
    CDatePicker,
    FindCustomer,
  },
})

export default class ContactCard extends Mixins(MainMixin) {
  @Prop() title!:string

  @Prop() shifts!:any

  @Prop() users!:any

  test(x:any) {
    console.log('test: ', x)
  }

  loading = false

  async submitForm() {
    this.loading = true
    try {
      console.log('submitting data:', this.data)
      console.log('subdata: ', this.subData)
      let { id } = this.data
      const testTags = clone(this.subData.customerTags)
      testTags.push(this.$store.state.location.gData.tags.master.id)
      console.log('testTags is : ', testTags)
      console.log('datatags: ', this.data.tags)
      const addTags = difference(testTags, this.data.tags)
      console.log('addTags is: ', addTags)
      if (!equals(this.data, this.originalData)) {
        const u:any = {
          firstName: this.data.firstName,
          lastName: this.data.lastName,
          phone: this.data.phone ? this.dbPhone(this.data.phone) : '',
          birthday: this.data.birthday || '',
          email: this.data.email,
        }
        const addInfusionContact = firebase.functions().httpsCallable('newInfusionContact')
        u.tags = addTags
        id = await addInfusionContact(u)
        console.log('here u is :', u)
        this.loading = false
        this.clearForm()
        return this.$toast.success(`Contact Successfully ${this.data.id ? 'Updated' : 'Added'}!`)
      }
      const addInfusionTag = firebase.functions().httpsCallable('addInfusionTag')
      const result = await addInfusionTag({ tags: addTags, id })
      this.loading = false
      console.log('result is: ', result)
      this.clearForm()
      return this.$toast.success('Contact Successfully Updated!')
    } catch (e) {
      console.log(e)
      this.loading = false
      return this.$toast.error('Error adding Contact')
    }
  }

  tempBirthday = ''

  @Watch('tempBirthday')
  updatedBirthday(bday:string) {
    this.data.birthday = dayjs(bday).format('YYYY-MM-DD')
  }

  get customerUpdated() {
    const ch = !equals(this.data, this.originalData)
    return (ch || this.subData.customerTags.length > 0 || this.hasCheck)
  }

  hasCheck = false

  data:any = {
  }

  subData:any = {
    user: this.$store.getters.uid,
    customerTags: [],
    check: '',
    spend: '',
  }

  originalData:any = {}

  searched = false

  customerTags:string[] = []

  actions = [
    {
      text: 'Joker Draw', value: this.$store.state.location.gData.tags.jokerDraw.id || '',
    },
    {
      text: 'Add To Text Club', value: this.$store.state.location.gData.tags.textClub.id || '',
    },
  ]

  presubmit() {

  }

  clearForm() {
    this.data = {}
    this.originalData = {}
    this.searched = false
    this.tempBirthday = ''
    this.subData = {
      user: this.$store.getters.uid,
      customerTags: [],
      check: '',
      spend: '',
    }
  }

  async findCustomer() {
    this.loading = true
    const mail = clone(this.data.email).trim().toLowerCase()
    this.data.email = mail
    const result = await db.collection('customers').where('email', '==', mail).get()
    if (result && result.empty) {
      this.data = { email: mail, tags: [] }
      this.originalData = { tags: [] }
    } else {
      this.data = result.docs[0].data()
      this.data.id = result.docs[0].ref.id
      this.data.phone = this.prettyPhone(this.data.phone)
      this.originalData = clone(this.data)
      this.tempBirthday = this.data.birthday ? dayjs(this.data.birthday).format('MM/DD/YYYY') : ''
    }
    this.loading = false
    this.searched = true
  }

  created() {
  }
}

